import * as THREE from 'three'
import {
  ThreeExt, CARD1Web
} from './CoordUtils.js';
import './thirdparty/loaders/OBJLoader'
import './thirdparty/loaders/MTLLoader'
import './thirdparty/loaders/DDSLoader'
import {
  GeometryManager, GeometryObject
} from './GeometryManager'

export class ModelLoader {
  constructor(sceneManager, modelInfo) {
    this.sceneManager = sceneManager;
    var camera = sceneManager.camera;
    this.modelInfo = modelInfo;
    this.locusMesh = null;
  }


  loadModel(oPosition, posSetFixed) {
    //先算Y值
    var positionA = this.sceneManager.geometryManager.helpModelPosition(oPosition.z,oPosition.x);
    var objLoader = new ThreeExt.OBJLoader();
    var mtlLoader = new ThreeExt.MTLLoader();
    // console.log('position',position)
    var _this = this;
    mtlLoader.setPath(this.modelInfo.modelPath).load(this.modelInfo.name + ".mtl", function(materials) {
      materials.preload();
      objLoader.setMaterials(materials);
      objLoader.setPath(_this.modelInfo.modelPath).load(_this.modelInfo.name + ".obj", function(loadedMesh) {
        if(_this.modelInfo.scale == undefined) _this.modelInfo.scale = 1;
        loadedMesh.scale.set(_this.modelInfo.scale, _this.modelInfo.scale, _this.modelInfo.scale);
        // 相机与Y的夹角
        loadedMesh.rotation.y = Math.PI/4;
        loadedMesh.position.copy(positionA);

        // loadedMesh.traverse(function(child) {
        //       if(child instanceof THREE.Mesh) {
        //         child.material.map(item=>{
        //           item.transparent=true;
        //           item.opacity = 0.3;
        //         })
        //       }
        //     });
        // console.log('_modelInfo',_this.modelInfo);
        // 降低取数据的层级，通过info的type来判断模型类型
        _this.sceneManager.geometryManager.addModel(_this.modelInfo.extraPartConfig.option.option, loadedMesh);
        // 加载单个模型触发回调
        _this.sceneManager.webView.afterModelLoad(_this.modelInfo.extraPartConfig.option.option.info);
        //创建新的对象并放置到鼠标位置
        if (posSetFixed == undefined) _this.sceneManager.currentMouseMovementAction.model =  loadedMesh;
        _this.loadedMesh = loadedMesh;
        loadedMesh.loader = _this;
        //some extra loading procedure
        _this.loadExtraParts(_this.modelInfo.extraPartConfig, loadedMesh);
      });
    });

  }

   setStake(startStake, endStake, lookAtPt){

    this.loadedMesh.lookAt(lookAtPt);
  }

  loadExtraParts(){

  }
  
  showRoute(route,roadStakes){
    var routePts = [];
    this.modelInfo.route = route;
    route.nodes.map(item=>{
      let position = this.sceneManager.geometryManager.helpModelPosition(item.z,item.x);
      routePts.push(position)
    })
    route.routePts = routePts;
    var path = new THREE.CatmullRomCurve3(routePts);
    var texture = new THREE.TextureLoader().load('static/bimroad/textures/arrow.png');
    texture.wrapT=THREE.RepeatWrapping;
    texture.wrapS=THREE.RepeatWrapping;
    texture.rotation=-Math.PI/2;
    texture.repeat.set(4,40);
    var material = new THREE.MeshLambertMaterial({
      map: texture,
      side:THREE.DoubleSide
    });
    var geometry = new THREE.TubeGeometry( path, 64, 0.2, 20, false );
    geometry = new THREE.BufferGeometry().fromGeometry( geometry );
    this.modelInfo.route.nMax = geometry.attributes.position.count;
    // var material = new THREE.MeshBasicMaterial( { color: '#409eff' } );
    var mesh = new THREE.Mesh( geometry, material );
    this.locusMesh = mesh;
    this.sceneManager.geometryManager.addLocusMesh(mesh);
  }

  showRoute1(route, roadStakes){
    var routePts = [];
    this.modelInfo.route = route;
    route.nodes.map(item=>{
      if (item.y == undefined){
        this.helper = new CARD1Web.CoordUtils.Helper();
        if (roadStakes == undefined){
            roadStakes = this.sceneManager.geometryManager.getMainRoad().roadModel.model.roadStake;
        }
        item.y = this.helper.getPtHeight(item,  roadStakes);
      }
      routePts.push(new THREE.Vector3(item.x, item.y, item.z));
    });

    route.routePts = routePts;
    var path = new THREE.CatmullRomCurve3(routePts);
    var texture = new THREE.TextureLoader().load('static/bimroad/textures/arrow.png');
    texture.wrapT=THREE.RepeatWrapping;
    texture.wrapS=THREE.RepeatWrapping;
    texture.rotation=-Math.PI/2;
    texture.repeat.set(4,40);
    var material = new THREE.MeshLambertMaterial({
      map: texture,
      side:THREE.DoubleSide
    });
    var geometry = new THREE.TubeGeometry( path, 64, 0.2, 20, false ); 
    // var material = new THREE.MeshBasicMaterial( { color: '#409eff' } );
    var mesh = new THREE.Mesh( geometry, material );
    this.sceneManager.geometryManager.addLocusMesh(mesh);
  }
  animateRoute(){
    this.modelInfo.route.start = 1;
    this.modelInfo.route.frameIndex = 0;
    this.sceneManager.animationManager.addAnimationTarget(this.loadedMesh.uuid,this);
    this.modelInfo.route.curPos = this.modelInfo.route.routePts[this.modelInfo.route.frameIndex];
    // @
    this.modelInfo.route.curLength = 0;
    //计算总长度以控制时间
    var totalLength = 0;
    for (var i = 0; i < this.modelInfo.route.routePts.length - 1; i++){
      totalLength += this.modelInfo.route.routePts[i].distanceTo(this.modelInfo.route.routePts[i+1]);
    }
    var time = 3;
    // @
    this.modelInfo.route.totalLength = totalLength;
    this.modelInfo.route.speed = 50;
    //记录原始位置以在动画结束前恢复
     this.modelInfo.route.orgPos = new THREE.Vector3 ();
     // console.log('lookAt',this.loadedMesh);
     this.modelInfo.route.orgPos.copy(this.loadedMesh.position);
  }
  moveAFrame(delta){
     if(this.modelInfo.route.start){
          var data = this.modelInfo.route.routePts;
          var distance = this.modelInfo.route.speed * delta;
          var nextPos = this.modelInfo.route.routePts[this.modelInfo.route.frameIndex + 1];
          var prevPos = this.modelInfo.route.routePts[this.modelInfo.route.frameIndex - 1]
          if (nextPos == undefined){
            debugger;
          }
          var remainLength = new THREE.Vector3(nextPos.x, nextPos.y, nextPos.z).sub(this.modelInfo.route.curPos).length();
          
          if (distance >= remainLength) {
              this.modelInfo.route.frameIndex = this.modelInfo.route.frameIndex + 1;
              this.modelInfo.route.curPos.copy(this.modelInfo.route.routePts[this.modelInfo.route.frameIndex]);
              if (this.modelInfo.route.frameIndex == this.modelInfo.route.routePts.length - 1){
                this.modelInfo.route.start = 0;
                this.sceneManager.animationManager.removeAnimationTarget(this.loadedMesh.uuid);
                this.loadedMesh.position.copy(this.modelInfo.route.orgPos);
                this.sceneManager.webView.endAnimateLocus();
              }
         }
          else{
            this.modelInfo.route.curLength+=distance;
            var alpha = distance / remainLength;
            this.modelInfo.route.curPos.lerp(nextPos, alpha);
          }
          this.loadedMesh.position.copy(this.modelInfo.route.curPos);
          var par = this.modelInfo.route.curLength/this.modelInfo.route.totalLength
          var num = this.modelInfo.route.nMax*par;
          num = Math.ceil(num);
          this.locusMesh.geometry.setDrawRange(0,num);
          //lookAt 朝向在个别地方会有bug
          if(prevPos&&prevPos.isVector3){
          this.loadedMesh.lookAt(prevPos)
            
          }
          
     }
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/ModelLoader.js